import styled from 'styled-components'

export default styled.button`
  cursor: pointer;
  width: ${(props) => `${props.size || 16}px`};
  height: ${(props) => `${props.size || 16}px`};
  mask-image: ${(props) => `url(/_next_static/icons/${props.icon}.svg)`};
  mask-size: contain;
  mask-position: center;
  mask-repeat: no-repeat;

  background-color: var(--${(props) => props.color || 'black'});
`
